import Command from '@ckeditor/ckeditor5-core/src/command';
import { Editor, Writer } from '@ckeditor/ckeditor5-core/src/editor';
import Position from '@ckeditor/ckeditor5-engine/src/model/position';
import TreeWalker from '@ckeditor/ckeditor5-engine/src/model/treewalker';
import { ResourceSectionIdAttr, ResourceIdsAttr } from './constants';
import { UpdateResourcelistCommandOptions } from './types';

export class UpdateResourceListSectionCommand extends Command {
  editor: Editor;

  constructor(editor: Editor) {
    super(editor);
    this.editor = editor;
  }

  execute({
    resourceIds,
    resourceSectionId,
  }: UpdateResourcelistCommandOptions): void {
    const { model } = this.editor;
    const { document } = model;

    model.change((writer: Writer) => {
      const rootBeginning = new Position(document.getRoot(), [0]);
      const iterator = new TreeWalker({ startPosition: rootBeginning });

      [...iterator].forEach((value) => {
        // TODO: @asimkt find better way to access the element than traversin whole tree.
        // Now this command is being used rarely, so not doing now.
        if (value.type === 'elementStart') {
          const sectionId = value.item.getAttribute(ResourceSectionIdAttr);

          if (sectionId && Number(sectionId) === resourceSectionId) {
            writer.setAttribute(ResourceIdsAttr, resourceIds, value.item);
          }
        }
      });
    });
  }
}
